import { useState } from "react";
import { TriangleAlert } from "lucide-react";
import { usePOS } from "@/context/POSContext";
import { useAdminData } from "@/hooks/useAdminData";
import StaffPanel from "@/components/admin/StaffPanel";
import RolesPanel from "@/components/admin/RolesPanel";
import { PageShell } from "@/components/PageShell";

/**
 * Staff accounts and roles. The cash shift and shift history that sat here were
 * removed (owner, 2026-11-02: "of no use"); the drawer is reckoned per day on
 * the Register page instead.
 */
export default function StaffPage() {
  const { token } = usePOS();
  const adminData = useAdminData(token);
  const [staffSubTab, setStaffSubTab] = useState("accounts");

  return <PageShell testId="staff-operations-page">
    {adminData.error && (
      <div className="bg-destructive/10 text-destructive border border-destructive/20 p-base rounded-lg flex items-start gap-snug shrink-0" role="alert" data-testid="staff-error"><TriangleAlert className="w-4 h-4 shrink-0 mt-hair"/><span className="text-body font-semibold">{adminData.error}</span></div>
    )}

    <div className="space-y-base" data-testid="staff-access-panel">
      <div className="flex items-center gap-1.5 p-1 bg-muted/40 rounded-lg border border-border w-fit">
        <button
          type="button"
          onClick={() => setStaffSubTab("accounts")}
          className={`px-3 py-1 rounded-md text-meta font-medium transition-all ${
            staffSubTab === "accounts"
              ? "bg-card text-foreground shadow-xs font-semibold"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          Staff accounts ({adminData.staff.length})
        </button>
        <button
          type="button"
          onClick={() => setStaffSubTab("roles")}
          className={`px-3 py-1 rounded-md text-meta font-medium transition-all ${
            staffSubTab === "roles"
              ? "bg-card text-foreground shadow-xs font-semibold"
              : "text-muted-foreground hover:text-foreground"
          }`}
          data-testid="staff-subtab-roles"
        >
          Roles
        </button>
      </div>

      <div className={staffSubTab === "accounts" ? "block" : "hidden"}>
        <div className="bg-card border rounded-lg overflow-hidden shadow-xs">
          <StaffPanel staff={adminData.staff} onSave={adminData.saveStaff} onDeactivate={adminData.deactivateStaff} onRemove={adminData.removeStaff}/>
        </div>
      </div>

      {staffSubTab === "roles" && (
        <div className="bg-card border rounded-lg overflow-hidden shadow-xs p-base">
          <RolesPanel catalog={adminData.catalog} rolePerms={adminData.rolePerms} onKindsChanged={adminData.reload} />
        </div>
      )}
    </div>
  </PageShell>;
}
